import { NavigationWrapper } from '../../navigation-data';
import { ShiveRoutes } from '../../segments/route-segments';

export const Dashboard: NavigationWrapper = {
  title: 'Dashboard',
  route: ShiveRoutes.Dashboard,
};
